import { TourCatalog } from "./contentfulModel.ts";
import React from "react";

export const TourCatalogCover: React.FC<{ tourCatalog: TourCatalog; tourOperatorLogoUrl: string }> = ({
                                                                                                          tourCatalog,
                                                                                                          tourOperatorLogoUrl
                                                                                                      }) => {
    const isMobile = window.innerWidth <= 768;
    const video = tourCatalog.backgroundVideo;
    // 1080p solo si la pantalla lo aprovecha (ancho físico > 1280px); si no, 720p para ahorrar datos
    const prefers1080 = window.innerWidth * (window.devicePixelRatio || 1) > 1280;
    const videoUrl = prefers1080
        ? video?.file_1080 || video?.file_720 || video?.file
        : video?.file_720 || video?.file_1080 || video?.file;
    const imageUrl = tourCatalog.backgroundImage?.file || tourCatalog.backgroundPoster?.file;
    const posterUrl = tourCatalog.backgroundPoster?.file || imageUrl;
    // El logo override y el del partner están pensados para fondo claro: van sobre una placa blanca
    const overrideLogoUrl = tourCatalog.overrideTourOperatorLogo?.file;
    const partnerLogoUrl = tourCatalog.partnerLogo?.file;
    const hasLightLogos = !!overrideLogoUrl || !!partnerLogoUrl;

    return (
        <div className="relative w-full h-full overflow-hidden bg-[#1C1C1C]">
            {/* Imagen: fondo si no hay vídeo, o alternativa para "reducir movimiento" */}
            {imageUrl && (
                <img
                    crossOrigin="anonymous"
                    className={`absolute top-0 left-0 w-full h-full object-cover ${
                        videoUrl ? "hidden motion-reduce:block" : ""
                    }`}
                    src={imageUrl}
                    alt={tourCatalog.name}
                />
            )}

            {/* Vídeo de fondo (tiene prioridad sobre la imagen) */}
            {videoUrl && (
                <video
                    className="absolute top-0 left-0 w-full h-full object-cover motion-reduce:hidden"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={posterUrl}
                    aria-hidden="true"
                >
                    <source src={videoUrl} type="video/mp4" />
                </video>
            )}

            {/* Tour Operator Logo - Top Right */}
            <div className="absolute top-0 p-[25px] w-full flex justify-end"
                 style={{ background: "linear-gradient(180deg, #11181E 0%, rgba(17, 24, 30, 0) 100%)" }}>
                <div className="flex items-center flex-col gap-2">
                    {hasLightLogos ? (
                        <div className="flex items-center gap-4 md:gap-6 bg-white/95 rounded-xl px-4 py-2 md:px-5 md:py-3 shadow-lg">
                            {overrideLogoUrl && (
                                <img
                                    crossOrigin="anonymous"
                                    src={overrideLogoUrl}
                                    alt="Tour Operator Logo"
                                    className="h-8 md:h-12 object-contain"
                                />
                            )}
                            {overrideLogoUrl && partnerLogoUrl && (
                                <span className="w-px self-stretch bg-[#E4DED4]" aria-hidden="true"/>
                            )}
                            {partnerLogoUrl && (
                                <img
                                    crossOrigin="anonymous"
                                    src={partnerLogoUrl}
                                    alt="Partner Logo"
                                    className="h-6 md:h-9 object-contain"
                                />
                            )}
                        </div>
                    ) : !isMobile ? (
                        <img
                            crossOrigin="anonymous"
                            src={tourOperatorLogoUrl}
                            alt="Tour Operator Logo"
                            className="h-12 object-contain"
                        />
                    ) : null}
                </div>
            </div>

            {/* Catalog Info - Bottom Left */}
            <div className="absolute bottom-0 text-white drop-shadow-lg w-full text-start p-[25px]"
                 style={{ background: "linear-gradient(0deg, #11181E 0%, rgba(17, 24, 30, 0) 100%)" }}>
                <h2 className="text-[50px] md:text-[90pt] md:leading-35 font-extrabold mb-0">
                    {tourCatalog.title || tourCatalog.name}
                </h2>
                {tourCatalog.subtitle && (
                    <p className="text-[0.8rem] md:text-[1.2rem] text-start uppercase">{tourCatalog.subtitle}</p>
                )}
            </div>
        </div>
    );
};
